import React, {  } from 'react';
import { InputNumber, Form, Input, DatePicker } from 'antd';

import locale from 'antd/es/date-picker/locale/ru_RU';
import dayjs from 'dayjs'
import 'dayjs/locale/ru'

import { IfElse } from '../../../common/Rule';

dayjs.locale('ru');

export default function IzmenitTarifi(props) {
    const { object, form, context } = props;
    return (
        <>
            <Form
                form={form}
                onFinish={props.submit}
                labelAlign={"left"}
                layout={"vertical"}
                initialValues={{
                    ...object,
                    dataVremyaOkonchaniya: (object) ? dayjs(object.dataVremyaOkonchaniya) : undefined,
                }}
            >
                <Form.Item label="Описание"
                    name="opisanie"
                    rules={[{ required: false, message: 'Пожалуйста, укажите описание!' }]}
                >
                    <Input />
                </Form.Item>
                { IfElse(context.tipTarifaID == 1, 
                    <Form.Item
                        label={"Окончание действия тарифа"}
                        name={"dataVremyaOkonchaniya"}
                        rules={[{ required: true, message: 'Пожалуйста, укажите окончание действия!' }]}
                    >
                        <DatePicker style={{ width: "100%" }} suffixIcon={<></>} showTime={{ format: 'HH:mm' }} format="YYYY-MM-DD HH:mm" locale={locale} />
                    </Form.Item>,
                    <Form.Item
                        label={"Количество проданных до"}
                        name={"kolichestvoDo"}
                        rules={[{ required: true, message: 'Пожалуйста, укажите количество проданных до!' }]}
                    >
                        <InputNumber min={0} />
                    </Form.Item>)
                }
                <Form.Item label="Сумма"
                    name="summa"
                    rules={[{ required: true, message: 'Пожалуйста, укажите сумму!' }]}
                >
                    <InputNumber />
                </Form.Item>
            </Form>
        </>
    );
}
